<template lang="pug">
div
  app-modal-solicitar-acesso(
    v-if="showModalSolicitarAcesso",
    :idsProcessosSelecionados="idsProcessos",
    @closeModal="showModalSolicitarAcesso = false"
    @limpar="limparEscolhas"
  )
  h1.title Buscar Processos

  .padding
    el-row(:gutter="15")
      el-col(:lg="8", :md="12", :sm="24")
        p.label Nome/Razão social do interessado:
        el-input.input(
          @keyup.native.enter="consultar"
          name="nomeInteressado",
          type="text",
          v-model="filtro.nomeInteressado"
        )

      el-col(:lg="8", :md="12", :sm="24")
        p.label CPF/CNPJ do interessado:
        el-input(
          @keyup.native.enter="consultar"
          type="text",
          name="cpfCnpjInteressado",
          v-mask="['###.###.###-##', '##.###.###/####-##']",
          v-model="filtro.cpfCnpjInteressado"
          )

      el-col(:lg="8", :md="12", :sm="24")
        p.label Número do processo:
        el-input.input(
          @keyup.native.enter="consultar"
          name="numeroProcesso",
          type="text",
          v-model="filtro.numeroProcesso"
        )
    el-row.button-row
      span.limpar(@click="clearBuscarProcesso") Limpar
      el-button(type="primary", @click="consultar")
        i.icon(class="fa fa-search")
        | Pesquisar

  h1 Resultado da pesquisa
  app-listagem(
    :has-refresh-button="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :showSolicitarAcesso="true"
    @changePage="changePage",
    @selectItem="selectItem",
    @selectAll="selectItems",
    @solicitarAcesso="solicitarAcesso"
    :hasMultipleCheckbox="false"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import { mapActions } from 'vuex'
import Filtro from '@/screens/analise/listagem/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import _ from 'lodash'
import AppModalSolicitarAcesso from './components/AppModalSolicitarAcesso.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {
  components: {
    AppListagem,
    Filtro,
    AppModalSolicitarAcesso
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('BUSCAR_PROCESSOS'),
      items: [],
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      totalElements: 0,
      infoPrazos: undefined,
      usuario: null,
      showModalSolicitarAcesso: false,
      configuracaoFiltro: {},
      processoEscolhido: [],
      idsProcessosSelecionados: [],
      idsProcessos: [],
      listaIDs: [],
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => true, ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'Nome/Razão social', propriedade: 'interessadoNomeRazaoSocial', ordem: 2, acoes: [] },
        { id: 3, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', ordem: 5, acoes: [] }
      ]
    }
  },

  props: {
    tipo: {
      type: String,
      required: false
    }
  },

  async created () {
    this.usuario = await this.getUsuario()
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario'
    }),
    solicitarAcesso () {
      this.showModalSolicitarAcesso = true
    },
    async consultar () {
      const { numeroProcesso: numeroProcessoFiltro, cpfCnpjInteressado: cpfInteressadoFiltro, nomeInteressado: nomeInteressadoFiltro } = this.filtro

      let pesquisaInvalida = _.isEmpty(numeroProcessoFiltro) || _.isEmpty(cpfInteressadoFiltro) || _.isEmpty(nomeInteressadoFiltro)

      let mensagem = 'Por favor, preencha os 3 campos para fazer a pesquisa.'

      if (nomeInteressadoFiltro.length < 3 && !pesquisaInvalida) {
        mensagem = 'Por favor, preencha o campo "Nome/Razão social do interessado" com pelo menos 3 caracteres.'
        pesquisaInvalida = true
      }

      if (pesquisaInvalida) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          mensagem
        )
      } else {
        await this.pesquisar(this.filtro)
      }
    },
    async selectItem (item) {
      if (item.selecionado === null) {
        item.selecionado = true
      } else {
        item.selecionado = !item.selecionado
      }
      if (item.selecionado) {
        const existe = this.idsProcessos.find(i => i === item.id)
        if (!existe) {
          this.idsProcessos.push(item.id)
        }
      } else {
        this.idsProcessos = this.idsProcessos.filter(i => i !== item.id)
      }
      await this.atualizarListagem()
    },
    async atualizarListagem () {
      const itemsAux = [...this.items]
      await this.refresh()
      this.items = [...itemsAux]
    },
    limparEscolhas () {
      this.idsProcessosSelecionados = []
      this.listaIDs = []
      this.clearBuscarProcesso()
    },
    selectItems (itens) {
      itens.forEach(processo => {
        this.idsProcessosSelecionados.push(processo.id)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
.button-row {
  margin-top: 15px;
  text-align: right;
}

.limpar {
  margin-right: 20px;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.icon {
  margin-right: 7px;
}
.padding {
  padding-left: 20px;
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/acompanharProcessos/CaixaBuscarProcessos.vue